import { createFileRoute } from "@tanstack/react-router";
import React from "react";

export const Route = createFileRoute("/$lang/blog/$blogId")({
  component: React.lazy(() =>
    import("@/pages/blogs/BlogDetailPage").then((mod) => ({
      default: mod.default,
    })),
  ),
});
